export { default as ScreenQuerySyncListener } from './ScreenQuerySyncListener';
